import xw from 'xwind';
import { Container, Section } from '@/components/layout';
import getUrlToS3 from '@/utils/get-url-to-s3';

import { Title, Line, TitleSection, TextSection } from './ContactUs.styles';

const ContactUs = (): JSX.Element => {
  function openLiveChat() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Intercom('show');
  }

  return (
    <Section>
      <Container css={xw`mt-11 mb-24`}>
        <div css={xw`w-full`}>
          <Title>Contact Us</Title>
          <Line />
        </div>
        <section>
          <div css={xw`flex items-center`}>
            <div css={xw`md:w-3/5`}>
              <TitleSection>Share Your Story</TitleSection>
              <TextSection>
                We love hearing your inspiring and helpful real life stories,
                and sharing them with our Village. If you’re interested in
                helping others based on your experience, please fill out our
                Real Life Story&nbsp;
                <a
                  css={xw`text-active underline`}
                  href="https://forms.gle/4Kvx7GgMVVPBaH1G6"
                  target="_blank"
                  rel="noreferrer"
                >
                  submission form.
                </a>
              </TextSection>
            </div>
            <div css={xw`hidden md:block w-2/5 pl-24`}>
              <img src={getUrlToS3('/contact/idea.png')} alt="idea" />
            </div>
          </div>
          <Line css={xw`w-32 md[w-5/6 mb-14 mt-20]`} />
        </section>
        <section>
          <div css={xw`md:flex`}>
            <div css={xw`md:w-6/12`}>
              <TitleSection>Supplier and Product Inquiries</TitleSection>
              <TextSection>
                If you are interested in selling your products or services on
                the OneVillage platform, please fill in our&nbsp;
                <a
                  css={xw`text-active underline`}
                  href="https://www.surveymonkey.com/r/HY5T2KZ"
                  target="_blank"
                  rel="noreferrer"
                >
                  Get Started
                </a>
                &nbsp;form.
              </TextSection>
            </div>
            <Line css={xw`w-32 md:hidden`} />
            <div css={xw`md[w-6/12 pl-20]`}>
              <TitleSection>Strategic Partner Inquiries</TitleSection>
              <TextSection>
                Strategic partnership inquiries from medical systems, payors,
                and advocacy groups can be directed to our&nbsp;
                <a
                  css={xw`text-active underline`}
                  href="mailto:partnerships@onevillage.io"
                >
                  Partnerships Team.
                </a>
              </TextSection>
            </div>
          </div>
          <Line css={xw`w-32 md[w-5/6 mt-14 mb-20]`} />
        </section>
        <section>
          <div css={xw`flex items-center`}>
            <div css={xw`hidden md:block w-6/12 pr-24`}>
              <img src={getUrlToS3('/contact/handshake.png')} alt="handshake" />
            </div>
            <div css={xw`md[w-6/12 pl-20]`}>
              <TitleSection>Product and Services Support</TitleSection>
              <TextSection>
                Need service or support? Take advantage of our&nbsp;
                <button
                  type="button"
                  css={xw`text-active underline focus:outline-none`}
                  onClick={openLiveChat}
                >
                  Live Chat
                </button>
                &nbsp;for quick answers. For more ways to get help, we’ll find
                you a solution if you email our&nbsp;
                <a
                  css={xw`text-active underline`}
                  href="mailto:support@onevillage.io"
                >
                  Support Team.
                </a>
              </TextSection>
            </div>
          </div>
        </section>
      </Container>
    </Section>
  );
};

export default ContactUs;
